<template>
    <div class="integration-mapping">

        <v-form
            v-if="items"
            ref="form"
            v-model="valid"
            @submit="onSubmit"
            :disabled="is_view">

            <v-container fluid>
                <v-row>

                    <!-- Machship fields -->
                    <v-col class="overflow-auto">
                        <div class="d-flex justify-end mb-5">
                            <TestFieldMapper :integration-id="id" class="mr-2" />
                            <v-btn
                                class="mr-2"
                                small
                                @click="shareFieldMapping">
                                {{ shareBtnText }}
                            </v-btn>
                            <AvailableFunctions ref="availableFunctionsRef" />
                        </div>
                        <table class="table table-mapping">
                            <thead>
                                <tr>
                                    <th>
                                        <h5 class="subtitle-2">Machship Field</h5>
                                    </th>
                                    <th colspan="2" class="bg-orange-panel">
                                        <h5 class="subtitle-2">Field Mapper</h5>
                                    </th>
                                    <th width="10"></th>
                                    <th colspan="2" class="bg-orange-panel">
                                        <h5 class="subtitle-2">Data Conversion</h5>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="machshipFields.length > 0 && items">

                                    <tr>
                                        <td class="msfield-column"></td>
                                        <td class="maptype-column bg-orange-panel pb-0">Map Type</td>
                                        <td class="bg-orange-panel pb-0">Source Field</td>
                                        <td></td>
                                        <td class="contype-column bg-orange-panel pb-0">Conversion Type</td>
                                        <td class="bg-orange-panel pb-0">Conversion Value</td>
                                    </tr>

                                    <!-- machship fields -->
                                    <tr
                                        v-for="(field, index) in machshipFields"
                                        :key="'field-' + index"
                                        class="p-3"
                                        :set="item = findItemByField(field)">
                                        <td class="pt-5">{{ field }}</td>
                                        <td class="bg-orange-panel control-td">
                                            <v-combobox
                                                dense
                                                :items="mapTypes"
                                                :value="item.map_type"
                                                :readonly="is_view"
                                                @change="onChangeItemMapType($event, field)">
                                            </v-combobox>
                                        </td>
                                        <td class="bg-orange-panel">
                                            <v-combobox
                                                dense
                                                :value="item.source_field"
                                                :items="sourceFields"
                                                :readonly="is_view"
                                                @change="onChangeSourceFields($event, field)"
                                            />
                                        </td>
                                        <td></td>
                                        <td class="bg-orange-panel control-td">
                                            <v-combobox
                                                dense
                                                :items="dataConverionTypes"
                                                menu-props="auto"
                                                :value="item.data_conversion_type"
                                                :readonly="is_view"
                                                @change="onChangeDataConversionType($event, field)">
                                            </v-combobox>
                                        </td>
                                        <td class="bg-orange-panel">
                                            <FunctionSelector
                                                :value="item.data_conversion_value"
                                                :conversion-type="item.data_conversion_type"
                                                :available-functions="availableFunctions"
                                                :readonly="is_view"
                                                @change="onChangeDataConversionValue($event, field)"
                                                @open-help="openFunctionHelp" />
                                        </td>
                                    </tr>

                                    <!-- START INTERNATIONAL FIELDS -->
                                    <tr v-if="machshipInternationalFields.length > 0" class="item-row-header mb-3" style="background-color: #fff8dc;">
                                        <td class="pt-5">
                                            <h5 class="mt-5 subtitle-2">International Fields</h5>
                                        </td>
                                        <td colspan="2" class="bg-orange-panel"></td>
                                        <td></td>
                                        <td colspan="2" class="text-right bg-orange-panel"></td>
                                    </tr>

                                    <tr
                                        v-for="(field, index) in machshipInternationalFields"
                                        :key="'ifield-' + index"
                                        class="p-3"
                                        :set="item = findItemByField(field)">
                                        <td class="pt-5">{{ field }}</td>
                                        <td class="bg-orange-panel control-td">
                                            <v-combobox
                                                dense
                                                :items="mapTypes"
                                                :value="item.map_type"
                                                :readonly="is_view"
                                                @change="onChangeItemMapType($event, field)">
                                            </v-combobox>
                                        </td>
                                        <td class="bg-orange-panel">
                                            <v-combobox
                                                dense
                                                :value="item.source_field"
                                                :items="sourceFields"
                                                :readonly="is_view"
                                                @change="onChangeSourceFields($event, field)"
                                            />
                                        </td>
                                        <td></td>
                                        <td class="bg-orange-panel control-td">
                                            <v-combobox
                                                dense
                                                :items="dataConverionTypes"
                                                menu-props="auto"
                                                :value="item.data_conversion_type"
                                                :readonly="is_view"
                                                @change="onChangeDataConversionType($event, field)">
                                            </v-combobox>
                                        </td>
                                        <td class="bg-orange-panel">
                                            <FunctionSelector
                                                :value="item.data_conversion_value"
                                                :conversion-type="item.data_conversion_type"
                                                :available-functions="availableFunctions"
                                                :readonly="is_view"
                                                @change="onChangeDataConversionValue($event, field)"
                                                @open-help="openFunctionHelp" />
                                        </td>
                                    </tr>
                                    <!-- END INTERNATIONAL FIELDS -->

                                    <!-- items -->
                                    <tr v-if="machshipItemFields.length > 0" class="item-row-header mb-3"  style="background-color: #fff8dc;">
                                        <td class="pt-5">
                                            <h5 class="mt-5 subtitle-2">Item *</h5>
                                        </td>
                                        <td colspan="2" class="bg-orange-panel"></td>
                                        <td></td>
                                        <td colspan="2" class="text-right bg-orange-panel"></td>
                                    </tr>
                                    <tr
                                        v-for="(field, index) in machshipItemFields"
                                        :key="'itemfield-' + index"
                                        class="p-1"
                                        :set="item = findItemByField(field)">
                                        <td class="pt-5">{{ field }}</td>
                                        <td class="bg-orange-panel control-td">
                                            <v-combobox
                                                dense
                                                :items="mapTypes"
                                                :value="item.map_type"
                                                :readonly="is_view"
                                                @change="onChangeItemMapType($event, field)">
                                            </v-combobox>
                                        </td>
                                        <td class="bg-orange-panel">
                                            <v-combobox
                                                dense
                                                :value="item.source_field"
                                                :items="sourceFields"
                                                :readonly="is_view"
                                                @change="onChangeSourceFields($event, field)"
                                            />
                                        </td>
                                        <td></td>
                                        <td class="bg-orange-panel control-td">
                                            <v-combobox
                                                dense
                                                :items="dataConverionTypes"
                                                menu-props="auto"
                                                :value="item.data_conversion_type"
                                                :readonly="is_view"
                                                @change="onChangeDataConversionType($event, field)">
                                            </v-combobox>
                                        </td>
                                        <td class="bg-orange-panel">
                                            <FunctionSelector
                                                :value="item.data_conversion_value"
                                                :conversion-type="item.data_conversion_type"
                                                :available-functions="availableFunctions"
                                                :readonly="is_view"
                                                @change="onChangeDataConversionValue($event, field)"
                                                @open-help="openFunctionHelp" />
                                        </td>
                                    </tr>
                                </template>

                                <template v-else>
                                    <tr>
                                        <td colspan="6"><p>No Mapped items</p></td>
                                    </tr>
                                </template>

                            </tbody>

                            <!-- Optional Items -->
                            <tfoot>
                                <template v-for="(row, ridx) in item_rows">
                                    <tr class="item-row-header" :key="'row-header-'+ridx">
                                        <td class="pt-5">
                                            <h5 class="mt-5 subtitle-2">Item {{ row }}</h5>
                                        </td>
                                        <td colspan="2" class="bg-orange-panel">
                                        </td>
                                        <td></td>
                                        <td colspan="2" class="text-right bg-orange-panel">
                                            <v-btn v-if="!is_view" fab @click="onRemoveItemRow(row)">
                                              <v-icon dark>mdi-minus</v-icon>
                                            </v-btn>
                                        </td>
                                    </tr>
                                    <tr
                                        v-for="(field, index) in getItemsByRow(row)"
                                        :key="'itemfield-' + row + '-' + index"
                                        :set="item = findItemByField(field)">
                                        <template v-if="!is_view || !isItemEmpty(item)">
                                            <td class="pt-5">{{ field }}</td>
                                            <td class="bg-orange-panel control-td">
                                                <v-combobox
                                                    dense
                                                    :items="mapTypes"
                                                    :value="item.map_type"
                                                    :readonly="is_view"
                                                    @change="onChangeItemMapType($event, field)">
                                                </v-combobox>
                                            </td>
                                            <td class="bg-orange-panel">
                                                <v-combobox
                                                    dense
                                                    :value="item.source_field"
                                                    :items="sourceFields"
                                                    :readonly="is_view"
                                                    @change="onChangeSourceFields($event, field)"
                                                />
                                            </td>
                                            <td></td>
                                            <td class="bg-orange-panel control-td">
                                                <v-combobox
                                                    dense
                                                    :items="dataConverionTypes"
                                                    menu-props="auto"
                                                    :value="item.data_conversion_type"
                                                    :readonly="is_view"
                                                    @change="onChangeDataConversionType($event, field)">
                                                </v-combobox>
                                            </td>
                                            <td class="bg-orange-panel">
                                                <FunctionSelector
                                                    :value="item.data_conversion_value"
                                                    :conversion-type="item.data_conversion_type"
                                                    :available-functions="availableFunctions"
                                                    :readonly="is_view"
                                                    @change="onChangeDataConversionValue($event, field)"
                                                    @open-help="openFunctionHelp" />
                                            </td>
                                        </template>
                                    </tr>
                                </template>
                            </tfoot>
                        </table>
                    </v-col>
                </v-row>
            </v-container>
            <div class="mt-3 p-3" v-if="!is_view">
                <v-btn class="mx-2" fab @click="onAddItemRow">
                  <v-icon dark>mdi-plus</v-icon>
                </v-btn>
            </div>
            <div class="mt-5 p-3 d-flex" v-if="!is_view">
                <v-spacer></v-spacer>
                <v-btn type="submit" small class="mr-1" color="primary" :disabled="isSubmit">
                    <span v-if="isSubmit">
                        <v-progress-circular
                            indeterminate
                            size="12"
                            width="2"
                            color="green darken-3">
                        </v-progress-circular>
                        updating...
                    </span>
                    <span v-else>Update</span>
                </v-btn>
            </div>
        </v-form>
        <v-progress-linear
            v-else
            indeterminate
            color="primary">
        </v-progress-linear>
    </div>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'
import AvailableFunctions from './AvailableFunctions.vue'
import FunctionSelector from './FunctionSelector.vue'
import TestFieldMapper from './TestFieldMapper.vue'

export default {
    components: { AvailableFunctions, FunctionSelector, TestFieldMapper },

    props: {
        id: { type: Number, default: null },
        direction: { type: String, default: 'from_machship' },
        is_view: { type: Boolean, default: false }
    },

    data() {
        return {
            valid: false,
            isSubmit: false,
            items: null,
            item_test: {
                data_direction: '',
                machship_field: '',
                map_type: '',
                source_field: '',
                data_conversion_type: '',
                integration_id: this.id
            },
            item_rows: [],

            dataDirections: [],
            dataConverionTypes: [],
            mapTypes: [],

            machshipFields: [],
            machshipInternationalFields: [],
            machshipItemFields: [],
            machshipItemOptFields: [],
            sourceFields: [],
            shareBtnText: "Share Field Mapping",
            originalShareBtnText: null,
            availableFunctions: []
        }
    },

    async mounted() {
        this.originalShareBtnText = this.shareBtnText;
        await this.fetchIntegration()
        await this.fetchFieldMapperOptions()
        await this.fetchAvailableFunctions()
    },

    methods: {

        async fetchAvailableFunctions() {
            try {
                // Request with expand_native=true to get individual native PHP functions for field mapper
                const response = await this.$http.get('/api/fieldmappers/functions?expand_native=true');
                // API already returns properly formatted data with name and shortDescription
                this.availableFunctions = response.data;
                console.log('Available functions:', this.availableFunctions);
            } catch (error) {
                console.error('Error fetching functions:', error);
            }
        },

        onAddItemRow() {
            if (this.item_rows.length > 0) {
                let last_row = this.item_rows[this.item_rows.length -1]
                this.item_rows.push(parseInt(last_row) + 1)
                return
            }

            this.item_rows = [0]
        },

        onRemoveItemRow(row) {
            let items = this.items.filter(item => {
                return item.machship_field.indexOf("items.[" + row) >= 0 && item.id
            }).map(item => {
                return item.id
            })

            let index = this.item_rows.indexOf(row)
            this.item_rows.splice(index, 1)

            if (items.length > 0) {
                this.$http
                    .post('/api/fieldmappers/removes', items)
                    .then(res => {

                        // we need to delete original client items too
                        this.items = this.items.filter(item => {
                            return item.machship_field.indexOf("items.[" + row) < 0
                        })
                    })
            }
        },

        onChangeItemMapType(e, field) {
            let index = this.items.findIndex(item => {
                return item.machship_field == field
            })

            // so user can clear its value
            let value = !e || this.isEmpty(e) ? '' : e.value
            this.items[index].map_type = value
        },

        onChangeSourceFields(e, field) {
            let index = this.items.findIndex(item => {
                return item.machship_field == field
            })

            this.items[index].source_field = e
        },

        onChangeDataConversionType(e, field) {
            let index = this.items.findIndex(item => {
                return item.machship_field == field
            })

            // so user can clear its value
            let value = !e || this.isEmpty(e) ? '' : e.value
            this.items[index].data_conversion_type = value
        },

        onChangeDataConversionValue(e, field) {
            let index = this.items.findIndex(item => {
                return item.machship_field == field
            })

            this.items[index].data_conversion_value = e
        },

        /**
         * This is useful for finding specific item by machship field
         *
         * @param      string  machship_field  The machship field
         * @param      boolean create          if we need to create if index not found
         * @return     object  mapped item
         */
        findItemByField(machship_field, create = true) {
            let index = this.items.findIndex(item => {
                return item.machship_field == machship_field
            })

            if (index >= 0) {
                return this.items[index]
            } else if (create) {
                return this.onAddMapping(machship_field)
            }
        },

        getItemsByRow(row) {
            let field_row = []

            // we only items that is existing for view type
            if (this.is_view) {
                this.machshipItemOptFields.forEach(field => {
                    field_row.push(field)
                })
            } else {
                this.machshipItemFields.forEach(field => {
                    let field_split = field.split(".")
                    let field_item = field_split[0] + '.[' + row + '].' + field_split[1]
                    field_row.push(field_item)
                })
            }

            return field_row
        },

        onSubmit(e) {
            e.preventDefault()

            if (this.$refs.form.validate()) {
                this.isSubmit = true

                setTimeout(() => {
                    this.$http
                        .post('/api/fieldmappers/bulk', this.items)
                        .then(({ data }) => {
                            EventBus.$emit('show-success', 'Successfully saved integrations.')
                            this.items = data
                            this.isSubmit = false
                        })
                        .catch(err => {
                            EventBus.$emit('show-error', err)
                            this.isSubmit = false
                        })
                }, 500)
            } else {
                EventBus.$emit('show-error', 'Fail! Please check all required fields')
            }
        },

        onAddMapping(field) {
            this.item_test.machship_field = field
            this.item_test.data_direction = this.direction
            let id = Math.random().toString(36).substring(7)
            let new_item = Object.assign({_id: id}, this.item_test)
            this.items.push(new_item)
            return new_item
        },


        fetchIntegration() {
            return new Promise((resolve, error) => {
                this.$http
                    .get('/api/fieldmappers/' + this.direction + '/' + this.id)
                    .then(({ data }) => {
                        this.items = data
                        this.checkMoreItems()
                        resolve(data)
                    })
                    .catch(err => {
                        EventBus.$emit('show-error', err);
                        error(err)
                    })
            })
        },

        fetchFieldMapperOptions() {
            this.$http
                .get('api/fieldmappers/options/' + this.id)
                .then(({ data }) => {
                    for (const index in data.options.directions) {
                        this.dataDirections.push({
                            value: index,
                            text: data.options.directions[index]
                        })
                    }

                    for (const index in data.options.conversion_types) {
                        this.dataConverionTypes.push({
                            value: index,
                            text: data.options.conversion_types[index]
                        })
                    }

                    for (const index in data.options.map_types) {
                        this.mapTypes.push({
                            value: index,
                            text: data.options.map_types[index]
                        })
                    }


                    data.machship_fields.sort()

                    for (const index in data.machship_fields) {

                        // if its for view, we handle it differently
                        if (this.is_view) {
                            let item = this.findItemByField(data.machship_fields[index], false);
                            if (this.isEmpty(item) || this.isItemEmpty(item)) {
                                // skip all empty machship fields
                                continue;
                            }
                        }

                        if (data.machship_fields[index].indexOf("items.") >= 0) {
                            this.machshipItemFields.push(data.machship_fields[index])
                        } else {
                            setTimeout(function() {
                                this.machshipFields.push(data.machship_fields[index])
                            }.bind(this), (index * 10))
                        }
                    }

                    for (const index in data.machship_international_fields) {

                        // if its for view, we handle it differently
                        if (this.is_view) {
                            let item = this.findItemByField(data.machship_international_fields[index], false);
                            if (this.isEmpty(item) || this.isItemEmpty(item)) {
                                // skip all empty machship fields
                                continue;
                            }
                        }

                        this.machshipInternationalFields.push(data.machship_international_fields[index])
                    }

                    for (const index in data.source_fields) {
                        this.sourceFields.push(data.source_fields[index])
                    }
                })
        },

        checkMoreItems() {

            // validate if items is not yet set
            if (!this.items) {
                return
            }

            // TODO to improve on getting more items row
            this.items.forEach(item => {
                if (item.machship_field.indexOf("items.[") >= 0) {
                    let split_items = item.machship_field.split("items.[")
                    if (split_items.length > 1) {
                        let split_number = split_items[1].split("].")
                        if (!this.item_rows[split_number[0]]) {
                            this.item_rows.push(split_number[0])
                        }

                        this.machshipItemOptFields.push(item.machship_field)
                    }
                }
            })
        },

        isItemEmpty(item) {
            return (
                this.isEmpty(item.map_type) &&
                this.isEmpty(item.source_field) &&
                this.isEmpty(item.data_conversion_type) &&
                this.isEmpty(item.data_conversion_value)
            );
        },

        shareFieldMapping() {
            this.shareBtnText = "Copied to clipboard";

            if (navigator.clipboard && navigator.clipboard.writeText) {
                let copiedTxt = "";

                this.items.forEach(item => {

                    if(!this.isItemEmpty(item)) {

                        copiedTxt +=
                            `Machship Field: ${item.machship_field}\n` +
                            `Map Type: ${item.map_type}\n` +
                            `Source Field: ${item.source_field}\n` +
                            `Conversion Type: ${item.data_conversion_type}\n` +
                            `Conversion Value: ${item.data_conversion_value}\n\n`;
                    }
                });

                const content = copiedTxt.replace(/\t/g, '');
                navigator.clipboard.writeText(content)
                    .catch((err) => {
                        console.error('Unable to copy content to clipboard', err);
                        EventBus.$emit('show-error', err);
                    });
            } else {
                EventBus.$emit('show-error', 'Clipboard API not supported in this environment.');
            }

            setTimeout(() => {
                this.shareBtnText = this.originalShareBtnText;
            }, 2000); // reset button text after 2 seconds
        },

        openFunctionHelp(functionName) {
            if (this.$refs.availableFunctionsRef) {
                this.$refs.availableFunctionsRef.openAndFocusFunction(functionName);
            }
        }

    }
}
</script>

<style scoped>
/* Table column widths */
.table-mapping .msfield-column {
    width: 200px;
    min-width: 200px;
}

.table-mapping .maptype-column {
    width: 160px;
    min-width: 160px;
}

.table-mapping .contype-column {
    width: 160px;
    min-width: 160px;
}

.table-mapping .control-td {
    width: auto;
}

/* Set table layout to fixed for consistent column widths */
.table-mapping {
    table-layout: fixed;
    width: 100%;
}

/* Source Field and Conversion Value columns */
.table-mapping tbody tr td:nth-child(3) {
    width: 25%;
}

.table-mapping tbody tr td:nth-child(6) {
    width: 25%;
}
</style>
